"use client";
import { Stack, Typography } from "@mui/material";

import { observer } from "../../../../service/mobx";
import InputBox from "./InputBox";
import OutputBox from "./OutputBox";
import useIO from "./InputBox/useIO";

function Play({ cluster }) {
  const { label, labelOutput, Input, Output, Examples, notLoaded } = useIO();

  return notLoaded ? null : (
    <Stack
      useFlexGap
      spacing={3}
      flexWrap="wrap"
      justifyContent="space-around"
      direction={{
        compact: "column",
        medium: "row",
        expanded: "column",
        large: "row"
      }}
    >
      <InputBox
        Input={Input}
        label={label}
        cluster={cluster}
        Examples={Examples}
      />
      {Output ? <OutputBox label={labelOutput} Output={Output} /> : null}
    </Stack>
  );
}

export default observer(Play);

export const Container = ({ children, label, small }) => (
  <Stack
    useFlexGap
    spacing={small ? 1 : 2}
    p={small ? 1 : 2}
    flex={1}
    border={small ? undefined : 1}
    maxWidth="100%"
    borderRadius="var(--shape-md-round)"
    borderColor="var(--outline-variant)"
    bgcolor={small ? undefined : "var(--surface-container-color)"}
  >
    <Typography
      pl={small ? 1 : undefined}
      color="var(--secondary-color)"
      variant={small ? "titleMd" : "titleLg"}
    >
      {label}
    </Typography>
    {children}
  </Stack>
);
